import { render, staticRenderFns } from "./BookingTableOog.vue?vue&type=template&id=2c60b86b&scoped=true"
import script from "./BookingTableOog.vue?vue&type=script&lang=js"
export * from "./BookingTableOog.vue?vue&type=script&lang=js"
import style0 from "./BookingTableOog.vue?vue&type=style&index=0&id=2c60b86b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c60b86b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c60b86b')) {
      api.createRecord('2c60b86b', component.options)
    } else {
      api.reload('2c60b86b', component.options)
    }
    module.hot.accept("./BookingTableOog.vue?vue&type=template&id=2c60b86b&scoped=true", function () {
      api.rerender('2c60b86b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trans/BookingTableOog.vue"
export default component.exports